import React, { Component } from "react";
import { Row } from 'react-bootstrap';
import 'mdbreact/dist/css/mdb.css';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBInput } from 'mdbreact';
import { Col,Image} from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator'
import { PostAPI } from "api/post";
import { getDomain } from "client-config";
import { Grid } from "react-bootstrap";

let logoValMain = require('../../../src/assets/img/maintenance.png');
const params = new URLSearchParams(window.location.search)
let urlhost = window.location.host;
let domain = urlhost.split('.')[0];
class ResetPassword extends Component {
 
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      element: (message, className) => <div style={{ width: '20rem', marginLeft: '55px' }} className="text-danger">{message}</div>,
    });
    this.currentDomain = getDomain((window.location.host).split('.')[0])
    this.state = {
      formData: {}, // Contains login form data
      errors: {}, // Contains login field errors
      formSubmitted: false, // Indicates submit status of login form
      loading: false,// Indicates in progress state of login form
      checked: false,
      checked1: false,
      showModal: false,
      showModal1: false,
      location: this.props.location,
      password: '',
      confirmPassword: '',
      showContent: false,
      showContentExpire: false      
    }
    this.submitReset = this.submitReset.bind(this);
    this.redirectLogin = this.redirectLogin.bind(this);     
  }

  submitReset = async (e) => {
    if (this.validator.allValid()) {
      const data = {
      resetPassword: this.state.password,
      confirmPassword: this.state.confirmPassword,
      token: params.get('uniqueToken')
      };


      
    //let url = 'http://sudhakar.esealcom.com:3003/forgot-password/password-reset';
      let url = `${this.currentDomain}:3003/forgot-password/password-reset`;
      PostAPI(url, data)
        .then(res => {
          if (res.status == 200) {
            if(res.data.data.status == 409) {
              swal({
                title: "Error!",
                text: "Unique Token Already Used!",
                icon: "error",
                timer: 2000,
                button: false
              }) 
            }
            else {
              swal({
                title: "Success!",
                text: "Password reset successfully!",
                icon: "success",
                timer: 2000,
                button: false
              })  
              this.props.history.push("/login");   
            }  
          }
          else {
            swal({
              title: "Invalid Credentials!",
              icon: "error",
              timer: 2000,
              button: false
            })
          }
          }).catch(function (error) {
          });
    } 
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  
  redirectLogin = async (e) => {
    window.location.href = "/login";
  }

  close1 = () => {
    this.setState({ showModal1: false});
  }
  close = () => {
    this.setState({ showModal: false });
  }

  open1 = () => {
    this.setState({ showModal:false,showModal1: true });
  }
  open = () => {
    this.setState({ showModal: true });
  }

  useQuery() {
    return new URLSearchParams(this.location.search);
  }
       
  handleCheckboxChange = event =>
  this.setState({ checked: event.target.checked })

  handleCheckboxChange1 = event =>
  this.setState({ checked: event.target.checked1 })

  handleInputChange = (event) => {
      const target = event.target;
      const value = target.value;
      const name = target.name;
      let { formData } = this.state;
      formData[name] = value;
      this.setState({
          formData: formData
      });
  }

  componentDidMount() {
      //let url = 'http://sudhakar.esealcom.com:3003/forgot-password/token-linkExpiry';
    let url = `${this.currentDomain}:3003/forgot-password/token-linkExpiry`;
    let data={
      token:  params.get('uniqueToken')
    }
    PostAPI(url,data)
      .then(res => {
        if (res.status == 200) {
          if(res.data.data.status == 409) {
            this.setState({ showContent:false });
            this.setState({ showContentExpire:true });
          }
          else {
            this.setState({ showContent:true }); 
            this.setState({ showContentExpire:false });
          }
        }
        else {
          this.setState({ showContent:false });
          this.setState({ showContentExpire:false });
        }
        //console.log(error);
      }).catch(function (error) {
    });
  }

  render() {
    return (
      <div>
        <div>
          {this.state.showContent == true ? 
          <div class="login"  style={{ minHeight: '100%',
            minWidth: '1024px', margin: '0 auto',
            backgroundImage: 'linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(/images/3.jpg)',
            backgroundSize: 'cover',
            overflow: 'hidden',width: '100%',
            height: 'auto',position: 'fixed',
            top: 0,
            left: 0
          }}>
            <MDBContainer className="col-md-6" style={{marginLeft:'35%',marginTop:'4%'}}>
              <MDBRow>
                <MDBCol md='6'>
                <MDBCard
                  className='card-image'
                  style={{
                      backgroundImage: 'url(/images/white-triangle.png)',
                      backgroundColor:'transparent',
                      width: '30rem', 
                      height: '50rem', 
                      backgroundPosition: 'center'
                  }}
                >
                  <div className='text-white rgba-stylish-strong py-5 px-5 z-depth-4'>
                  <Row>
                    <Col xs={12} md={4}> </Col>
                    <Col xs={6} md={4}>
                      <Image src={require('../../assets/img/logo.png')} roundedCircle
                      style={{height:'50px',width:'50px',marginLeft:'18%',marginTop:'25%'}} />
                    </Col>
                  </Row>
                  <div className='text-center'>
                    <h3 className='white-text mb-5 mt-4 font-weight-bold' >
                      <strong>Reset</strong>
                      <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                        <strong> Password</strong>
                      </a>
                    </h3>
                  </div>
                   
                  <div style={{paddingTop: '10px'}}>
                    <MDBInput
                      style={{ width: '20rem', marginLeft: '55px', color: 'white' }}
                      type='text'
                      label='Enter new password '
                      placeholder="Password"
                      value={this.state.password}
                      onChange={e => this.setState({ password: e.target.value })}
                      name="password"
                    />
                    {this.validator.message('Enter new password', this.state.password, 'required|min:6')}
                    <MDBInput
                      type='password'
                      validate size="lg"
                      label='Re-enter new password'
                      style={{width:'20rem',marginLeft:'55px',color:'white', marginTop: '30px'}}
                      placeholder="Confirm Password"
                      value={this.state.confirmPassword}
                      onChange={e => this.setState({ confirmPassword: e.target.value })}
                      name="password"
                    />
                    {this.validator.message('Re-enter new password', this.state.confirmPassword, `required|min:6|in:${this.state.password}`, {messages: {in: 'Passwords need to match!'}})}
                  </div>

                  <MDBRow>
                    <MDBCol>
                    <div md="4" className="mb-4">
                      <MDBBtn  color='red' style={{
                          borderRadius: '20px',
                          width: '8rem',
                          marginLeft: '71px',
                          marginTop: '30px',
                          fontSize: '0.9rem',
                          marginBottom: '75px',
                          backgroundColor: "'#BB4738' !important"
                      }}
                        
                        rounded
                        type='button'
                        className='btn-block z-depth-1'
                        onClick={this.redirectLogin}
                      >
                        Cancel
                      </MDBBtn>
                    </div>
                    </MDBCol>
                    <MDBCol>
                    <div md="4" className="mb-4">
                      <MDBBtn  color='red' style={{
                          borderRadius: '20px',
                          width: '8rem',
                          marginLeft: '193px',
                          marginTop: '-105px',
                          fontSize: '0.9rem',
                          marginBottom: '75px',
                          backgroundColor: "'#BB4738' !important"
                      }}
                        rounded
                        type='button'
                        className='btn-block z-depth-1'
                        onClick={this.submitReset}
                      >
                        Submit
                      </MDBBtn>
                    </div>
                    </MDBCol>
                  </MDBRow>
                  </div>
                </MDBCard>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
          :
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
          </div>
          }
        </div>       
        {this.state.showContentExpire == true ? 
          <div className="content">
            <Grid fluid>
              <div className="text-center" style={{ margin:"200px", marginTop: '100px !important'}}>
                <img style={{width:'50px', marginTop: '0px'}} src={logoValMain} alt="logo_image" />
                <h3>Unique Token Expired</h3>
                <h5>You have already used your token for reset password</h5>
                <h5>Please try again by clicking on forgot password of Login</h5>
                <MDBBtn color='red' style={{
                  borderRadius: '17px',
                  fontSize: '0.9rem',
                  width: '13%',
                  marginLeft: '375px'
                }}
                  rounded
                  type='button'
                  className='z-depth-1 col-md-4'
                  onClick={this.redirectLogin}
                >
                  Login
                </MDBBtn>
              </div>
            </Grid>
          </div>  
        : '' }
      </div>              
    )
  }
}

export default ResetPassword;